export default __webpack_public_path__ + "static/media/planet.16956ba4.png";